import ButtonControl from '../button-control'
import Icon from '../assets'
import { manuallyFocusElement } from './helper'

interface Props {
  value?: string[] | string
  placeholder?: string
  feature?: string
  onInput?: (e: Event) => void
  onSubmit: Function
  onClear?: OnClickCallback
  isModerationOverview?: boolean
}

function handleSubmit (event: Event, onSubmit: Function) {
  event.preventDefault()

  const { target } = event
  const input = (target as HTMLElement).querySelector('input')

  if (!input) return

  const value = input.value.trim()

  if (!value) return

  onSubmit(value)
}

const SearchBox = ({ value, placeholder, onInput, onSubmit, onClear, isModerationOverview, feature }: Props) => {
  const inputClassName = `qa-search-box-filter${feature ? `-${feature}` : ''}`
  const isOldTopicModerationPage = !!window.inSidedData?.content?.topic?.id
  return (
    <div className='control-search-box'>
      <form onSubmit={((event: Event) => handleSubmit(event, onSubmit))}>
        {isModerationOverview && <Icon width={16} height={16} icon='search' />}
        <input
          className={inputClassName}
          type='text'
          value={value}
          placeholder={placeholder}
          maxLength={500}
          onInput={onInput}
          onClick={() => { if (isOldTopicModerationPage) manuallyFocusElement(inputClassName) }}
        />
        {isModerationOverview && value && <Icon
          icon='close'
          width={16}
          height={16}
          onClick={onClear}
                                          />}
        {!isModerationOverview && <ButtonControl variant='primary' type='submit' icon='search' />}
      </form>
    </div>
  )
}

export default SearchBox
